import React from 'react'
import ImageContainer from './ImageContainer'


function Imagelab() {
  return (
    <div>
      <ImageContainer/>
    </div>
  )
}

export default Imagelab
